module.exports = __webpack_public_path__ + "static/media/IMG_20200207_021412.c2f4e30d.jpg";